module.exports = {
  Webpage: {
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    PluginName: "Webpage",
    radius: "Radius",
    source: "Source",
    URL: "URL",
    URL_copypaste: "Copy & paste an URL",
    fixedPosition: "Remove scrollbar",
  },
};
